export const genericDropdownParser = (idKey, nameKey) => (data) => {
    let parsedData = []
    Array.isArray(data) && data.forEach(entry => {
        parsedData = [...parsedData,
            {
                name: entry[nameKey],
                id: entry[idKey]
            }
        ]
    });
    return parsedData;
}